export const GATEWAY_API_URL = import.meta.env.VITE_GATEWAY_API_URL

export const API_LOGIN_SCOPE_URL = import.meta.env.VITE_API_LOGIN_SCOPE_URL

export const HELP_CENTER_URL = import.meta.env.VITE_HELP_CENTER_URL
